(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pls-section-js"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    function updateScrollClasses(wrapper) {
      if (!wrapper) return;

      const canScrollTop = wrapper.scrollTop > 10;
      const canScrollBottom = wrapper.scrollTop + wrapper.clientHeight < wrapper.scrollHeight - 10;

      wrapper.parentElement.classList.toggle("can-scroll-top", canScrollTop);
      wrapper.parentElement.classList.toggle("can-scroll-bottom", canScrollBottom);
    }

    const scrollableContainers = document.querySelectorAll(".product-line--products");
    scrollableContainers.forEach((scrollableContainer) => {
      updateScrollClasses(scrollableContainer);
      scrollableContainer.addEventListener("scroll", () => updateScrollClasses(scrollableContainer));
      window.addEventListener("resize", () => updateScrollClasses(scrollableContainer));
    });

    const list = document.querySelector(".product-lines--list");

    if (list) {
      const onScroll = () => {
        const expanded = list.querySelector(".product-line.expanded");
        if (!expanded) return;


        const listTop = list.getBoundingClientRect().top;
        const expandedTop = expanded.getBoundingClientRect().top;

        if (expandedTop <= listTop) {
          list.classList.add("touching-top");
        } else {
          list.classList.remove("touching-top");
        }
      };

      list.addEventListener("scroll", onScroll);
      window.addEventListener("resize", onScroll);
      onScroll();
    }

    const lineItems = document.querySelectorAll(".product-lines-section .product-line");

    lineItems.forEach((item) => {
      const section = item.closest(".product-lines-section");
      const summary = item.querySelector(".product-line--summary");
      const details = item.querySelector(".product-line--details");

      const openItem = (item, details) => {
        item.classList.add("expanded");
        details.style.display = "block";

        const fullHeight = details.scrollHeight;
        details.style.height = "0px";

        requestAnimationFrame(() => {
          details.style.height = fullHeight + "px";
        });

        setTimeout(() => {
          const scrollContainer = item.closest(".product-lines--list");

          if (scrollContainer) {
            const hasNext = !!item.nextElementSibling;

            const scrollTop = Math.max(item.offsetTop - scrollContainer.offsetTop - 20, 0);
            scrollContainer.scrollTo({
              top: hasNext ? scrollTop : scrollContainer.scrollHeight,
              behavior: "smooth",
            });
          }
        }, 300);

        const itemIndex = item.dataset.index;
        const itemMedia = section.querySelector(`.product-line--media[data-index="${itemIndex}"]`);
        const itemList = section.querySelector(`.product-line--detail[data-index="${itemIndex}"]`);
        itemMedia.classList.add("active");
        if (window.innerWidth > 992) {
          itemMedia.querySelector("video")?.play();
        }
        itemList.classList.add("active");
      };

      const closeItem = (item, details) => {
        details.style.height = details.scrollHeight + "px";

        requestAnimationFrame(() => {
          details.style.height = "0px";
        });

        item.classList.remove("expanded");

        const itemIndex = item.dataset.index;
        const itemMedia = section.querySelector(`.product-line--media[data-index="${itemIndex}"]`);
        const itemList = section.querySelector(`.product-line--detail[data-index="${itemIndex}"]`);
        itemMedia.classList.remove("active");
        itemMedia.querySelector("video")?.pause();
        itemList.classList.remove("active");
      };

      if (item.classList.contains("expanded")) {
        details.style.display = "block";
        details.style.height = "auto";
      } else {
        details.style.display = "block";
        details.style.height = "0px";
      }

      summary.addEventListener("click", (e) => {
        e.stopPropagation();
        if (!item.classList.contains("expanded")) {
          const prevOpen = section.querySelector(".product-line.expanded");
          if (prevOpen) {
            closeItem(prevOpen, prevOpen.querySelector(".product-line--details"));
          }
          openItem(item, details);
        } else {
          const nextItem = item.nextElementSibling ? item?.nextElementSibling?.nextElementSibling : lineItems[0];
          closeItem(item, details);
          openItem(nextItem, nextItem.querySelector(".product-line--details"));
        }
      });

      details.addEventListener("transitionend", () => {
        if (item.classList.contains("expanded")) {
          details.style.height = "auto";
        }
      });
    });

    const lineProductItems = document.querySelectorAll(".product-lines-section .pl--item");
    lineProductItems.forEach((item) => {
      const itemsList = item.closest(".product-line--products");
      const itemDetails = item.querySelector(".pl--details");

      const openItem = (item, details) => {
        const itemViewMore = item.querySelector(".pl--product-view-more");
        item.classList.add("expanded");
        details.style.display = "block";

        const fullHeight = details.scrollHeight;
        details.style.height = "0px";

        requestAnimationFrame(() => {
          details.style.height = fullHeight + "px";
          itemViewMore.innerText = "Esconder detalhes";
        });
      };

      const closeItem = (item, details) => {
        const itemViewMore = item.querySelector(".pl--product-view-more");
        details.style.height = details.scrollHeight + "px";

        requestAnimationFrame(() => {
          details.style.height = "0px";
          itemViewMore.innerText = "Ver detalhes";
        });

        item.classList.remove("expanded");
      };

      item.addEventListener("click", (e) => {
        e.stopPropagation();
        if (!item.classList.contains("expanded")) {
          const prevOpen = itemsList.querySelector(".pl--item.expanded");
          if (prevOpen) {
            closeItem(prevOpen, prevOpen.querySelector(".pl--details"));
          }
          openItem(item, itemDetails);
        } else {
          closeItem(item, itemDetails);
        }
      });

      itemDetails.addEventListener("transitionend", () => {
        if (item.classList.contains("expanded")) {
          itemDetails.style.height = "auto";
        }
      });
    });

    const viewButtons = document.querySelectorAll(".product-line--view-items");
    viewButtons.forEach((viewButton) => {
      viewButton.addEventListener("click", function () {
        const section = viewButton.closest(".product-lines-section");
        const productLine = viewButton.closest(".product-line");
        const lineIndex = productLine.dataset.index;
        const itemsList = section.querySelector(`.product-line--detail[data-index="${lineIndex}"]`).cloneNode(true);
        const lineTitle = productLine.querySelector(".product-line-title .text").textContent;
        const cartForm = productLine.querySelector(".product-line--actions form").cloneNode(true);
        const pricing = productLine.querySelector(".product-line--price .price").cloneNode(true);
        appendLineItemsPopup(itemsList, lineTitle, cartForm, pricing);
      });
    });

    function appendLineItemsPopup(itemsList, lineTitle, cartForm, pricing) {
      const popupOverlay = document.createElement("div");
      popupOverlay.classList = "items-popup-overlay";

      popupOverlay.insertAdjacentHTML(
        "beforeend",
        `
        <div class="items-popup">
          <div class="items-popup-wrapper">
            <div class="popup-header">
              <h2 class="popup-title">${lineTitle}</h2>
              <button type="button" class="popup-header-close button-effect" aria-label="Fechar">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"></path></svg>
                Fechar
              </button>
            </div>

            <div class="popup-body">

            </div>

            <div class="line-form-wrapper">
              <div class="line-pricing"></div>
            </div>
          </div>
        </div>
      `
      );

      itemsList.classList.add("custom-scrollbar-mb");
      itemsList.style.overflowX = "hidden";
      pricing.querySelector(".price_with__installments")?.classList.remove("hidden");
      popupOverlay.querySelector(".popup-body").appendChild(itemsList);
      popupOverlay.querySelector(".line-pricing").appendChild(pricing);
      popupOverlay.querySelector(".line-form-wrapper").appendChild(cartForm);
      popupOverlay.querySelector(".popup-header-close").addEventListener("click", function () {
        popupOverlay.remove();
        document.body.classList.remove("items-popup-open");
      });

      itemsList.querySelectorAll(".pl--item").forEach((item) => {
        item.querySelector(".plus-sign")?.remove();
        item.querySelector(".pl--product-view-more")?.remove();
        item.insertAdjacentHTML(
          "beforeend",
          `<button class="button pl--item-open">
            <svg
              role="presentation"
              focusable="false"
              width="8"
              height="6"
              class="icon icon-chevron-down"
              viewBox="0 0 8 6"
            >
              <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
          </button>`
        );

        const itemsList = item.closest(".product-line--products");
        const itemDetails = item.querySelector(".pl--details");

        const openItem = (item, details) => {
          item.classList.add("expanded");
          details.style.display = "block";

          const fullHeight = details.scrollHeight;
          details.style.height = "0px";

          requestAnimationFrame(() => {
            details.style.height = fullHeight + "px";
          });
        };

        const closeItem = (item, details) => {
          details.style.height = details.scrollHeight + "px";

          requestAnimationFrame(() => {
            details.style.height = "0px";
          });

          item.classList.remove("expanded");
        };

        item.addEventListener("click", (e) => {
          e.stopPropagation();
          if (!item.classList.contains("expanded")) {
            const prevOpen = itemsList.querySelector(".pl--item.expanded");
            if (prevOpen) {
              closeItem(prevOpen, prevOpen.querySelector(".pl--details"));
            }
            openItem(item, itemDetails);
          } else {
            closeItem(item, itemDetails);
          }
        });

        itemDetails.addEventListener("transitionend", () => {
          if (item.classList.contains("expanded")) {
            itemDetails.style.height = "auto";
          }
        });
      });

      document.body.classList.add("items-popup-open");
      document.body.appendChild(popupOverlay);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-accessories"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const checkboxes = document.querySelectorAll(".product-accessories-wrapper .product-item-checkmark");

    function updateAccessoryTotals() {
      let totalPrice = 0;
      let totalComparePrice = 0;

      document.querySelectorAll('.product-accessories-wrapper .product-item[data-checked="true"]').forEach((item) => {
        totalPrice += Number(item.dataset.price || 0);
        totalComparePrice += Number(item.dataset.compareAtPrice || 0);
      });

      const totalSelectedEl = document.querySelector(".product-accessories .total-selected");
      const totalCompareSelectedEl = document.querySelector(".product-accessories .total-compare-selected");

      if (totalSelectedEl) {
        totalSelectedEl.textContent = Shopify.formatMoney(totalPrice, window.money_format);
      }

      if (totalCompareSelectedEl) {
        totalCompareSelectedEl.textContent = Shopify.formatMoney(totalComparePrice, window.money_format);

        if (totalPrice >= totalComparePrice) {
          totalCompareSelectedEl.classList.add("hidden");
        } else {
          totalCompareSelectedEl.classList.remove("hidden");
        }
      }
    }

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const productItem = this.closest(".product-item");
        if (!productItem) return;

        productItem.dataset.checked = this.checked ? "true" : "false";
        updateAccessoryTotals();
      });
    });

    updateAccessoryTotals();

    const addAccessoriesToCartBtn = document.querySelector(".add-accessories-to-cart-button");
    addAccessoriesToCartBtn.addEventListener("click", function () {
      let formData = {
        items: [],
      };
      const ids = document
        .querySelectorAll('.product-accessories-wrapper .product-item[data-checked="true"]')
        .forEach((item) => {
          formData.items.push({ id: item.dataset.productVariantId, quantity: 1 });
        });

      if (formData.items.length > 0) {
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            Shopify.getCart((cart) => {
              window.updateCart(cart);
            });
            return response.json();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
